

const ms230 = {
  label: "KMPatrak",
  pageLabel: "KMPatrak",
  starting: true,
  url: "ms230",
  pageType: "history",
  formTabs: {
    allTabs: [
      {
        label: "Filter",
        uid: "filter",
        style: { fontFamily: "verdana" }
      },
      {
        label: "Create",
        uid: "create",
        style: { fontFamily: "verdana" }
      }
    ]
  },
  form: [
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Parent Branch",
      label: "Parent Branch",
      name: "Parentbranch",
      description: "Enter Parent Branch"
    },
    {
      inputType: "autocomplete",
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "branch-1",
          value: "branch-1"
        },
        {
          label: "branch-2",
          value: "branch-2"
        },
        {
          label: "branch-3",
          value: "branch-3"
        }
      ],
      placeHolder: "Branch Code",
      //   label: "Branch Code",
      name: "branch",
      description: "Enter branch code"
    },
    {
      inputType: "showdata",
      tab: "filter",
      data: "branch",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-5",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Society",
      label: "Society",
      name: "",
      description: "Enter Society"
    },
    {
      inputType: "autocomplete",
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "society-1",
          value: "society-1"
        },
        {
          label: "society-2",
          value: "society-2"
        },
        {
          label: "society-3",
          value: "society-3"
        }
      ],
      placeHolder: "society",
      //   label: "Branch Code",
      name: "society",
      description: "Enter society"
    },
    {
      inputType: "showdata",
      tab: "filter",
      data: "society",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Parent Branch",
      label: "Parent Branch",
      name: "",
      description: "Enter Parent Branch"
    },
    {
      inputType: "autocomplete",
      isRequired: true,
      tab: "create",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "branch-1",
          value: "branch-1"
        },
        {
          label: "branch-2",
          value: "branch-2"
        },
        {
          label: "branch-3",
          value: "branch-3"
        }
      ],
      placeHolder: "Branch Code",
      //   label: "Branch Code",
      name: "Parentbranch",
      description: "Enter branch code"
    },
    {
      inputType: "showdata",
      tab: "create",
      data: "Parentbranch",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Date",
      label: "Date",
      name: "",
      description: "Date"
    },
    {
      inputType: "date",
      tab: "create",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "Date",
      name: "Date",
      description: "Date"
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Society",
      label: "Society",
      name: "",
      description: "Enter Society"
    },
    {
      inputType: "autocomplete",
      isRequired: true,

      tab: "create",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "society-1",
          value: "society-1"
        },
        {
          label: "society-2",
          value: "society-2"
        },
        {
          label: "society-3",
          value: "society-3"
        }
      ],
      placeHolder: "society",
      //   label: "Branch Code",
      name: "society",
      description: "Enter society"
    },
    {
      inputType: "showdata",
      tab: "create",
      data: "society",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-5",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Product",
      label: "Product",
      name: "",
      description: "Enter Product"
    },
    {
      inputType: "autocomplete",
      isRequired: true,

      tab: "create",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "product1",
          value: "product1"
        },
        {
          label: "product2",
          value: "product2"
        },
        {
          label: "product3",
          value: "product3"
        }
      ],
      placeHolder: "Branch Code",
      //   label: "Branch Code",
      name: "product",
      description: "Enter 2 digit branch code"
    },
    {
      inputType: "showdata",
      tab: "create",
      data: "product",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-5",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Account No.",
      label: "Account No.",
      name: "",
      description: "Enter Account No. Text"
    },
    {
      inputType: "numberonly",
      isRequired: true,

      tab: "create",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Enter Account No",
      label: "",
      name: "accountNo",
      description: "Enter Account No"
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Member Shares",
      label: "Member Shares",
      name: "",
      description: "Enter Member Shares Text"
    },
    {
      inputType: "text",
      tab: "create",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Enter Member Shares",
      label: "",
      name: "memberShares",
      description: "Enter Member Shares"
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Loan Account",
      label: "Loan Account",
      name: "",
      description: "Enter Loan Account"
    },
    {
      inputType: "numberonly",
      tab: "create",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Enter Loan Account",
      label: "",
      name: "loanAccount",
      description: "Enter Loan Account"
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Loan Type",
      label: "Loan Type",
      name: "",
      description: "Enter Loan Type"
    },
    {
      inputType: "autocomplete",
      tab: "create",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "product1",
          value: "product1"
        },
        {
          label: "product2",
          value: "product2"
        },
        {
          label: "product3",
          value: "product3"
        }
      ],
      placeHolder: "Loan Type",
      //   label: "Loan Type",
      name: "loanType",
      description: "Enter 2 digit Loan Type"
    },
    {
      inputType: "showdata",
      tab: "create",
      data: "loanType",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-5",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Loan O/S Amount",
      label: "Loan O/S Amount",
      name: "",
      description: "Enter Loan O/S Amount"
    },
    {
      inputType: "numberonly",
      tab: "create",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Enter Loan O/S Amount",
      label: "",
      name: "loanO/SAmount",
      description: "Enter Loan O/S Amount"
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "e-karar amount",
      label: "e-karar amount",
      name: "",
      description: "Enter e-karar amount"
    },
    {
      inputType: "numberonly",
      isRequired: true,
      tab: "create",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Enter e-karar amount",
      label: "",
      name: "e-kararamount",
      description: "Enter e-karar amount"
    }
  ],
  history: {
    perPage: 10,
    reportHeader: "User Statement",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    displayColumns: [
      {
        Header: "Account Code",
        accessor: "LoginName",
        width: 150
      },
      {
        Header: "Account Name",
        accessor: "lastname",
        width: 150
      },
      {
        Header: "Request Date",
        accessor: "email"
      },
      {
        Header: "Name On Card",
        accessor: "mobile"
      }
    ]
  }
};

export default ms230;
